import { render } from "./Void.vue?vue&type=template&id=4bbf4dfa"
import script from "./Void.vue?vue&type=script&lang=js"
export * from "./Void.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__